import { GiftCardSuccessItem } from "molecules/containers/gift-card-success-item";
import {
  Treatment,
  TreatmentProps,
} from "molecules/containers/treatment/Treatment";

export interface TreatmentListProps {
  treatments: TreatmentProps[];
}

export const TreatmentOrderedList = ({ treatments }: TreatmentListProps) => {
  if (!treatments.length) return null;

  return (
    <div>
      <div className="divide-y divide-solid divide-background-two overflow-clip rounded-lg shadow-subtle">
        {treatments.map((treatment) => {
          // Use custom gift card component for gift cards
          if (treatment.type === "GiftCard") {
            return (
              <GiftCardSuccessItem
                key={treatment.id}
                id={treatment.id}
                imgUrl={treatment.imgUrl}
                title={treatment.title}
                session={treatment.session}
                onClick={treatment.onClick}
              />
            );
          }

          // Use regular treatment component for other items
          return <Treatment key={treatment.id} {...treatment} />;
        })}
      </div>
    </div>
  );
};
